import _extends from "@babel/runtime/helpers/esm/extends";
import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["hasCounter", "hasLabel", "hint", "initialRows", "label", "maxLength", "maximumRows", "minimumRows", "onBlur", "onChange", "onFocus", "placeholder", "theme", "variant", "value"];
import React, { useState } from 'react';
import PropTypes from 'prop-types';
import withTheme from '../theme/withTheme';
import { TextAreaContainer, TextAreaInput, TextDelimiter, Characters, Wrapper, Label, Hint } from './styles';
var TextArea = function TextArea(_ref) {
  var hasCounter = _ref.hasCounter,
    hasLabel = _ref.hasLabel,
    hint = _ref.hint,
    initialRows = _ref.initialRows,
    label = _ref.label,
    maxLength = _ref.maxLength,
    maximumRows = _ref.maximumRows,
    minimumRows = _ref.minimumRows,
    onBlur = _ref.onBlur,
    onChange = _ref.onChange,
    onFocus = _ref.onFocus,
    placeholder = _ref.placeholder,
    theme = _ref.theme,
    variant = _ref.variant,
    _ref$value = _ref.value,
    value = _ref$value === void 0 ? '' : _ref$value,
    rest = _objectWithoutProperties(_ref, _excluded);
  var id = rest.id;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    focused = _useState2[0],
    setFocused = _useState2[1];
  var _useState3 = useState(initialRows),
    _useState4 = _slicedToArray(_useState3, 2),
    rows = _useState4[0],
    setRows = _useState4[1];
  var _useState5 = useState(''),
    _useState6 = _slicedToArray(_useState5, 2),
    inputValue = _useState6[0],
    setValue = _useState6[1];
  function handleChange(event) {
    var textareaLineHeight = 24;
    var previousRows = event.target.rows;
    event.target.rows = minimumRows; // eslint-disable-line no-param-reassign

    // eslint-disable-next-line no-bitwise
    var currentRows = ~~(event.target.scrollHeight / textareaLineHeight);
    if (currentRows === previousRows) {
      event.target.rows = currentRows; // eslint-disable-line no-param-reassign
    }

    if (currentRows >= maximumRows) {
      event.target.rows = maximumRows; // eslint-disable-line no-param-reassign
      event.target.scrollTop = event.target.scrollHeight; // eslint-disable-line no-param-reassign
    }

    setValue(event.target.value);
    setRows(currentRows < maximumRows ? currentRows : maximumRows);
    if (onChange) {
      onChange(event);
    }
  }
  function handleFocus(event) {
    setFocused(true);
    if (onFocus) {
      onFocus(event);
    }
  }
  function handleBlur(event) {
    setFocused(false);
    if (onBlur) {
      onBlur(event);
    }
  }
  return /*#__PURE__*/React.createElement(TextAreaContainer, {
    theme: theme,
    variant: variant
  }, /*#__PURE__*/React.createElement(Wrapper, {
    focused: focused,
    variant: variant,
    theme: theme
  }, hasLabel && /*#__PURE__*/React.createElement(Label, {
    theme: theme,
    variant: variant,
    focused: focused,
    htmlFor: id
  }, label), /*#__PURE__*/React.createElement(TextDelimiter, null, /*#__PURE__*/React.createElement(TextAreaInput, _extends({
    value: inputValue || value,
    rows: rows,
    placeholder: placeholder,
    variant: variant,
    onFocus: function onFocus(event) {
      return handleFocus(event);
    },
    onChange: function onChange(event) {
      return handleChange(event);
    },
    onBlur: function onBlur(event) {
      return handleBlur(event);
    },
    theme: theme,
    maxLength: maxLength
  }, rest)))), hasCounter && /*#__PURE__*/React.createElement(Characters, {
    theme: theme,
    variant: variant
  }, "".concat(inputValue.length || value.length, " de ").concat(maxLength, " caracteres")), hint && variant === 'error' && /*#__PURE__*/React.createElement(Hint, {
    theme: theme,
    variant: variant
  }, hint));
};
export default withTheme(TextArea);
process.env.NODE_ENV !== "production" ? TextArea.propTypes = {
  hasLabel: PropTypes.bool
} : void 0;
TextArea.defaultProps = {
  hasLabel: true
};